import * as Types from '../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ProductCatalogAdsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ProductCatalogAdsQuery = {
  __typename?: 'Query';
  productCatalogAds: {
    __typename?: 'ProductCatalogAds';
    brandPromoMosaic?: {
      __typename?: 'ProductCatalogBrandPromoMosaic';
      tiles: Array<{
        __typename?: 'ProductCatalogBrandPromo';
        customRedirectUrl?: string | null;
        brand: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string };
        mobileImage?: { __typename?: 'Photo'; id: string; url: string } | null;
        image: { __typename?: 'Photo'; id: string; url: string };
      }>;
    } | null;
    departmentBrandPromos: Array<{
      __typename?: 'ProductCatalogDepartmentBrandPromo';
      department: { __typename?: 'ProductCatalogCategory'; id: string; title: string };
      categoryCarousel?: {
        __typename?: 'ProductCatalogBrandPromo';
        customRedirectUrl?: string | null;
        brand: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string };
        mobileImage?: { __typename?: 'Photo'; id: string; url: string } | null;
        image: { __typename?: 'Photo'; id: string; url: string };
      } | null;
      navBar?: {
        __typename?: 'ProductCatalogBrandPromo';
        customRedirectUrl?: string | null;
        brand: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string };
        mobileImage?: { __typename?: 'Photo'; id: string; url: string } | null;
        image: { __typename?: 'Photo'; id: string; url: string };
      } | null;
      productGrid?: {
        __typename?: 'ProductCatalogBrandPromo';
        customRedirectUrl?: string | null;
        brand: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string };
        mobileImage?: { __typename?: 'Photo'; id: string; url: string } | null;
        image: { __typename?: 'Photo'; id: string; url: string };
      } | null;
    }>;
  };
};

export type CatalogBrandPromoFragment = {
  __typename?: 'ProductCatalogBrandPromo';
  customRedirectUrl?: string | null;
  brand: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string };
  mobileImage?: { __typename?: 'Photo'; id: string; url: string } | null;
  image: { __typename?: 'Photo'; id: string; url: string };
};

export const CatalogBrandPromoFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogBrandPromo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogBrandPromo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customRedirectUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProductCatalogAdsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductCatalogAds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogAds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brandPromoMosaic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tiles' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogBrandPromo' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departmentBrandPromos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'department' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryCarousel' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogBrandPromo' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'navBar' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogBrandPromo' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productGrid' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogBrandPromo' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogBrandPromo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogBrandPromo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customRedirectUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductCatalogAdsQuery__
 *
 * To run a query within a React component, call `useProductCatalogAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogAdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCatalogAdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>) {
  return ApolloReactHooks.useQuery<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>(ProductCatalogAdsDocument, baseOptions);
}
export function useProductCatalogAdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>(ProductCatalogAdsDocument, baseOptions);
}
export type ProductCatalogAdsQueryHookResult = ReturnType<typeof useProductCatalogAdsQuery>;
export type ProductCatalogAdsLazyQueryHookResult = ReturnType<typeof useProductCatalogAdsLazyQuery>;
export type ProductCatalogAdsQueryResult = Apollo.QueryResult<ProductCatalogAdsQuery, ProductCatalogAdsQueryVariables>;
